import React, { PureComponent } from "react";
import styled from "styled-components";

import TeamSelector from './team-selector';

export const SelectorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 12px;
`;

export const TeamSelectorLabel = styled.span`
  font-family: 'Mukta Vaani';
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-right: 8px;
`;

class TeamSelectorWrapper extends PureComponent {
  render() {
    const { label, selectorOptions, onSelectorChange, selectorSelectedOptionId } = this.props;

    return (
      <SelectorWrapper>
        <TeamSelectorLabel>{label}</TeamSelectorLabel>
        <TeamSelector options={selectorOptions} onSelectorChange={onSelectorChange} selectedOptionId={selectorSelectedOptionId}></TeamSelector>
      </SelectorWrapper>
    );
  }
}

export default TeamSelectorWrapper;



// WEBPACK FOOTER //
// ./src/instructor/components/performance-feedback/components/team-selector-wrapper.js